export default __webpack_public_path__ + "static/media/icon-person-success-female-desktop.92f0965a.svg";